import React from 'react';
import ContentText from '@solid-ui-components/ContentText';
import { Flex, Box } from 'theme-ui';
import { styles } from './styles';
import ContentIcon from '@solid-ui-components/ContentIcon';
import ContentButtons from '@solid-ui-components/ContentButtons/ContentButtons';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper/LayoutWrapper';
import Reveal from '@solid-ui-components/Reveal/Reveal';

const {
  container,
  reviewWrapper,
  review,
  reviewLeft,
  reviewTextLeft,
  reviewTextRight
} = styles;

const ClickableReview = ({ content }) => {
  return (
    <LayoutWrapper>
      <Box sx={container}>
        <Flex sx={reviewWrapper}>
          {content.collection.map((item, index) => (
            <Flex key={index} sx={{ ...review, ...reviewLeft }}>
              <Flex sx={item.buttons ? reviewTextLeft : { ...reviewTextLeft, ...styles.reviewTextLeftNoButton }}>
                <Reveal effect={'fadeInDown'}>
                  {item.text.slice(0, 1).map((textItem, index) => (
                    <ContentText sx={{ mt: ['none', 'none', 'none', 'none', '40px'], mb: ['10px', '10px', '10px', '10px', '60px'] }} key={index} content={textItem} />
                  ))}
                </Reveal>
                <Reveal effect={'fadeInDown'}>
                  {item.buttons && (
                    <ContentButtons
                      content={item.buttons}
                    />
                  )}
                </Reveal>
              </Flex>
              <Flex sx={reviewTextRight}>
                {item.icon && <ContentIcon content={item.icon} size='sm' />}
                <Reveal effect={'fadeInUp'}>
                  {item.text.slice(1, 2).map((textItem, index) => (
                    <ContentText key={index} content={textItem} />
                  ))}
                </Reveal>
                {item.icon && (
                  <Box sx={{ rotate: '180deg' }}>
                    <ContentIcon content={item.icon} size='sm' />
                  </Box>
                )}
                <Reveal effect={'fadeInUp'}>
                  {item.text.slice(2).map((textItem, index) => (
                    <ContentText key={index} content={textItem} />
                  ))}
                </Reveal>
              </Flex>

            </Flex>
          ))}
        </Flex>
      </Box>
    </LayoutWrapper>
  );
};



export default ClickableReview;
